export default {
	sizes: {
		mobile: '450px',
		tablet: '834px'
	}
};
